import styled from "styled-components";
import params from "../../global/params.json";

const containerParams = params.container;

export const Container = styled.div`
  h4 {
    padding: 0 0 10px 10px;
    font-size: 24px;
  }
  .coin-box {
    background-color: black;
    color: #fff;
    font-size: 14px;
    padding: 10px 20px;
    border-radius: 25px;
    margin-bottom: 20px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .subflex {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  padding: 112px 20px 0px 20px;
  width: 100%;
  margin: 0 auto;
  max-width: 1300px;
  .staking-card {
    border-radius: 25px;
    background-color: #ebebeb;
    margin-bottom: 20px;
    border: 2px solid black;
  }
  .staking-innercard {
    border-radius: 25px;
    text-align: center;
    padding-top: 25px;
    padding-bottom: 5px;
    background: black;
    position: relative;
    margin: -2px;
    .stk-absolute__logo1 {
      width: 50px;
      position: absolute;
      top: 20px;
      left: 20px;
      opacity: 0.7;
    }
    .stk-absolute__logo2 {
      width: 150px;
      position: absolute;
      bottom: 0px;
      right: 20px;
      opacity: 0.7;
    }
    h4 {
      font-size: 16px;
      color: var(--title-color);
    }
    .stk-price {
      font-size: 24px;
      color: #eeeeee;
      padding: 10px 0px;
      font-weight: 700;
    }
    .stk-price-sub {
      font-size: 14px;
      color: var(--title-color);
      margin-bottom: 15px;
    }
    .stk-btn {
      margin: 0px auto;
      width: 210px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 15px;
      gap: 10px;

      .stk-income-btn1 {
        border: var(--secondaryColor) 2px solid;
        background: var(--secondaryColor);
        color: #eeeeee;
        padding: 7px 10px;
        border-radius: 5px;
        font-weight: 700;
        align-items: center;
        display: flex;
        min-width: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.5s;
        &:hover {
          opacity: 0.8;
        }
      }
      .stk-income-btn2 {
        border: var(--secondaryColor) 2px solid;
        color: var(--secondaryColor);
        background: #eeeeee;
        padding: 7px 10px;
        border-radius: 5px;
        font-weight: 700;
        min-width: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.5s;
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
  .background-trading {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    min-width: 1200px;
    z-index: -1;
  }
  .stk-rewards {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    &__card {
      width: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      small {
        font-size: 14px;
        margin-bottom: 5px;
        color: var(--title-color);
      }
      span {
        font-size: 16px;
        color: #fff;
      }
    }
    .first-card {
      border-right: 1px solid rgb(77, 91, 144);
    }
  }
  .stk-card2-title1 {
    text-align: center;
    font-size: 15px;
    color: #eeeeee;
    padding-top: 15px;
  }
  .stk-card2-title2 {
    text-align: center;
    font-size: 15px;
    color: #eeeeee;
  }
  .stk-card2-title {
    padding: 10px;
    text-align: center;
    font-size: 15px;
    color: #eeeeee;
  }
  .stk-card2-footer {
    color: var(--title-color);
    font-size: 12px;
    padding-bottom: 15px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      color: #eeeeee;
      padding: 0 5px;
    }
  }
  .stk-invite-box {
    background: black;
    border-radius: 25px;
    font-size: 14px;
    margin: 10px 15px;
    align-items: center;
    display: flex;
    p {
      padding-left: 15px;
      color: #fff;
      flex: 1;
    }
    button {
      background: var(--secondaryColor);
      padding: 10px 15px;
      border-radius: 25px;
      font-weight: bold;
      color: #eeeeee;
      border: none;
    }
  }
  .staking-list {
    width: 100%;
    padding-bottom: 100px !important;
    th {
      width: 33.3%;
      font-size: 15px;
      color: #000;
      text-align: center;
      padding: 20px 0px;
      border-bottom: 2px solid #362b72bd;
    }
    td {
      color: #000;
      text-align: center;
      padding: 10px 0px;
      border-bottom: 1px solid #1f164f75;
    }
  }

  .flex {
    display: flex;
  }
  .space-between {
    justify-content: space-between;
  }
  .flex-column {
    flex-direction: column;
  }
  .gap {
    gap: 10px;
  }
  .padding-20 {
    padding: 20px;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
  .pg-back-btn {
    cursor: pointer;
    margin-top: -20px;
    padding: 20px;
    color: var(--primaryColor);
    background-color: transparent;
    border: none;
    border-radius: 15px;
    font-weight: bold;
    font-size: 20px;
    display: flex;
    align-items: center;
    transition: all 0.5s;
    p {
      margin: 5px 0 0 5px;
    }
    img {
      width: 30px;
      color: var(--primaryColor);
    }
    &:hover {
      opacity: 0.8;
    }
  }
  .pg-stk {
    &__title {
      font-size: 35px;
      margin-bottom: 10px;
      text-align: center;
    }
    &__subtitle {
      font-size: 20px;
      text-align: center;
      margin-bottom: 20px;
    }
  }
  .stk-balance {
    background-color: #1b1e29;
    color: var(--title-color);
    padding: 15px 25px;
    border-radius: 10px;
    border-bottom: 1px #172c52 dashed;
    margin-bottom: 0;
    align-items: center;
    small {
      font-size: 14px;
    }
    span {
      font-size: 19px;
      color: #fff;
      font-weight: 700;
    }
    button {
      color: var(--primaryColor);
      padding: 10px 15px;
      font-size: 12px;
      border-radius: 25px;
      background: var(--secondaryColor);
      font-weight: 700;
      border: none;
      transition: all 0.3s;
      font-weight: bold !important;
      line-height: 1;
      &:hover {
        opacity: 0.8;
      }
    }
  }

  .stk-now {
    color: var(--title-color);
    border-radius: 10px;
    small,
    p,
    span,
    input {
      display: block;
    }
    .title {
      font-size: 16px;
      font-weight: 700;
    }
    .title2 {
      font-size: 14px;
      padding: 10px 0px;
    }
    .stk-amount-input {
      margin-top: 15px;
      border-radius: 5px;
      border: #151c2b solid 2px;
      padding: 5px;
      background: #141923;
      color: white;
      width: 100%;
      text-align: center;
      transition: all 0.5s;
      &::placeholder {
        color: var(--title-color);
      }
      &:focus {
        border: #1f2b45 solid 2px;
        outline: none;
      }
      &:active {
        outline: none;
      }
    }
    .stk-divider {
      width: 100%;
      height: 12px;
      margin-top: 10px;
      border-radius: 10px;
      background-color: #333e53;
    }
    .stk-amount-sub {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 10px;
      font-size: 14px;
      span {
        padding: 0 5px;
        color: #fff;
      }
    }
    .stk-date {
      border-top: 1px #172c52 dashed;
      font-size: 14px;
      padding: 10px 0px;
      margin: 15px 0;
    }
    .stk-btn-action {
      font-size: 14px;
      height: 40px;
      text-align: center;
      background: linear-gradient(90deg, #09ba8e, #00a);
      color: #05122a;
      border-radius: 5px;
      font-weight: 700;
      width: 100%;
      border: none;
      transition: all 0.3s;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .stk-card-reward2 {
    width: 50%;
    padding: 15px 25px;
    border-radius: 10px;
    background: #141923;
    color: var(--title-color);
    border-radius: 10px;
    display: flex;
    flex-direction: column;

    &__title {
      font-size: 14px;
      margin-bottom: 5px;
    }
    &__value {
      color: #fff;
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 5px;
    }
    &__sub-value {
      font-weight: 700;
      font-size: 13px;
      margin-bottom: 5px;
    }
    &__info {
      font-size: 12px;
      color: #435577;
    }
  }
`;
